import { C_ACTION } from '../constans';

export const packaging = (state = [], action) => {
  switch (action.type) {
    case C_ACTION.ADD_PACKAGE: {
      return [...action.data];
    }
    default:
      return state;
  }
};
